import { Tabs } from "antd";
import { useState } from "react";
import PageHeaders from "../../components/pageHeaders";
import Expense from "./expense";
import ExpenseCategory from "./expenseCategory";
import ProfitLoss from "./profitLoss";

const ExpenseScreen = () => {
  const [activeTab, setActiveTab] = useState("expense");

  const onChange = (key: any) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: "expense",
      label: "Expense",
      children: <Expense />,
    },
    {
      key: "category",
      label: "Expense Category",
      children: <ExpenseCategory />,
    },
    {
      key: "profitLoss",
      label: "Profit & Loss",
      children: <ProfitLoss />,
    },
  ];

  const getBreadcrumb = () => {
    switch (activeTab) {
      case "expense":
        return "Expense Management";
      case "category":
        return "Expense Category";
      case "profitLoss":
        return "Profit & Loss Statement";
      default:
        return "Expense Management";
    }
  };

  return (
    <div>
      <PageHeaders title={"Expense"} breadcrumb={getBreadcrumb()} />
      <Tabs activeKey={activeTab} onChange={onChange} items={items} />
    </div>
  );
};

export default ExpenseScreen;
